module.exports = (__parcel__import__("1Fonl")).then(() => parcelRequire('4MKVl'));